import { __awaiter, __generator } from "tslib";
import { ErrorHandler } from '@angular/core';
import { Store } from '@ngrx/store';
import { Auth } from 'aws-amplify';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpService } from 'src/app/core/services/http.service';
import { reportError } from 'src/app/core/services/sentry.utils';
import * as AuthActions from '../actions/auth.actions';
import { environment } from './../../../environments/environment';
var AuthService = /** @class */ (function () {
    function AuthService(_store, _errorHandler, _httpService) {
        this._store = _store;
        this._errorHandler = _errorHandler;
        this._httpService = _httpService;
        this._store.dispatch(new AuthActions.GetClinicId());
    }
    AuthService.prototype.getClinicId = function (hostname) {
        if (hostname === void 0) { hostname = window.location.hostname; }
        if (environment.environment === 'local' ||
            (environment.environment === 'test' &&
                (hostname === 'localhost' || hostname === '127.0.0.2'))) {
            var defaultSubdomain = 'meditex1';
            //// you can map 127.0.0.x IP addresses to different subdomains for local testing of multiple clinics
            // const subdomain =
            //   hostname === '127.0.0.2' ? 'vrepro-salve-validation' : defaultSubdomain;
            hostname = defaultSubdomain + "." + hostname;
            // hostname = `testsalveclinicv2.${hostname}`;
            // hostname = `testsalveclinic.${hostname}`;
            // hostname = `ccrmtest.${hostname}`;
            // hostname = `testsalvecore.${hostname}`;
            // hostname = 'uk-demo.salvehealth.co';
            // hostname = `mathe-mellowood-consent.${hostname}`;
            // hostname = `vrepro-salve-validation.${hostname}`;
        }
        var postParams = {
            Action: 'getclinicbysubdomain',
            Input: hostname
        };
        return this._httpService
            .performPublicPostRequest(postParams, '/clinicbysubdomain')
            .pipe(catchError(function (err) {
            return throwError(err);
        }));
    };
    AuthService.prototype.cognitoLogout = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, Auth.signOut()];
            });
        });
    };
    AuthService.prototype.cognitoLogin = function (primaryLoginInfo) {
        return __awaiter(this, void 0, void 0, function () {
            var cognitoUser, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, Auth.signIn(primaryLoginInfo)];
                    case 1:
                        cognitoUser = _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        reportError(e_1, 'auth.cognitoLogin');
                        return [2 /*return*/, {
                                message: "Error Signing in cognito user",
                                originalError: e_1
                            }];
                    case 3: return [2 /*return*/, cognitoUser];
                }
            });
        });
    };
    AuthService.prototype.verifyOTP = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var cognitoUser, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, Auth.sendCustomChallengeAnswer(params.user, params.code)];
                    case 1:
                        cognitoUser = _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_2 = _a.sent();
                        reportError(e_2, 'auth.verifyOTP');
                        return [2 /*return*/, {
                                message: "Error Verify OTP",
                                originalError: e_2
                            }];
                    case 3: return [2 /*return*/, cognitoUser];
                }
            });
        });
    };
    AuthService.prototype.cognitoCompletePassword = function (submissionData) {
        return __awaiter(this, void 0, void 0, function () {
            var user, password, requiredAttributes, e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        user = submissionData.user, password = submissionData.password, requiredAttributes = submissionData.requiredAttributes;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, new Promise(function (resolve, reject) {
                                user.completeNewPasswordChallenge(password, requiredAttributes, {
                                    onSuccess: function () {
                                        resolve({ user: user });
                                    },
                                    onFailure: function (err) {
                                        console.error('Failed to complete password challenge', err);
                                        reject(err);
                                    },
                                    customChallenge: function () {
                                        // this is the main callback that will get called probably 100% of the time because we in our Cognito lambdas always return customChallenge (which means OTP) after user sets their password for the first time
                                        // down the line OTPRequired will be dispatched which will navigate to OTP page
                                        resolve({ result: 'customChallenge', user: user });
                                    }
                                });
                            })];
                    case 2: 
                    /**
                     * Implementing direct call to CognitoUser object by the example of how Amplify's Auth.completeNewPassword does it. Their completeNewPassword method is essentially a wrapper with some preset logic.
                     * But in contrast to Amplify we implement the customChallenge callback that we must provide for our use case. And this makes the whole flow work.
                     */
                    return [2 /*return*/, _a.sent()];
                    case 3:
                        e_3 = _a.sent();
                        reportError(e_3, 'auth.completePassword');
                        return [2 /*return*/, {
                                message: "Error Completing New Password",
                                originalError: e_3
                            }];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AuthService.prototype.cognitoResetPassword = function (submissionData) {
        return __awaiter(this, void 0, void 0, function () {
            var email, code, new_password, res, e_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        email = submissionData.email, code = submissionData.code, new_password = submissionData.new_password;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, Auth.forgotPasswordSubmit(email, code, new_password)];
                    case 2:
                        res = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_4 = _a.sent();
                        reportError(e_4, 'auth.resetPassword');
                        console.error(e_4);
                        throw new Error("Error Completing New Password");
                    case 4: return [2 /*return*/, res];
                }
            });
        });
    };
    AuthService.prototype.cognitoGenerateResetCode = function (submissionData) {
        return __awaiter(this, void 0, void 0, function () {
            var email, res, e_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        email = submissionData.email;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, Auth.forgotPassword(email)];
                    case 2:
                        res = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_5 = _a.sent();
                        reportError(e_5, 'auth.generateResetCode');
                        console.error(e_5);
                        throw new Error("Error Generating Code");
                    case 4: return [2 /*return*/, res];
                }
            });
        });
    };
    return AuthService;
}());
export { AuthService };
